// extracted by mini-css-extract-plugin
export default {"body":"PartRow_body__fqWSC"};